const SERVICE_API_URL = "https://api.brainyhoot.com";
//const SERVICE_API_URL = "http://localhost:8080";

export default SERVICE_API_URL;